<template>
  <div class="Seat">
    <mu-container>
      <mu-row gutter>
        <mu-col span="12" lg="12" sm="12">
          <mu-date-input
            v-model="BookDate"
            :min-date="TodyDate"
            :should-disable-date="disableWeekends"
            icon="today"
            label="预约日期"
            container="bottomSheet"
            label-float
            full-width
            @change="DateChange"/>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col span="12">
          <label>上午</label>
        </mu-col>
        <TimeTag :time-list="getBookTime.MoTime" @SelInfo="ShowSelInfo" @AddSelItem="AddSelItem" @RemSelItem="RemSelItem" @CanselBook="CanselBook"/>
      </mu-row>

      <mu-row gutter>
        <mu-col span="12">
          <label>下午</label>
        </mu-col>
        <TimeTag :time-list="getBookTime.AfTime" @SelInfo="ShowSelInfo" @AddSelItem="AddSelItem" @RemSelItem="RemSelItem" @CanselBook="CanselBook"/>
      </mu-row>
    </mu-container>

    <mu-container style="margin-bottom: 34px">
      <mu-button full-width color="primary" @click="BookHandel">预约</mu-button>
    </mu-container>

    <mu-container>
      <mu-dialog :open.sync="InfoVisable" title="预约信息" width="360">
        <div> 经办人：{{ SelItem.UserName }} </div>
        <div> 电话：{{ SelItem.Mobile }} </div>
        <div> 申请单位：{{ SelItem.CompName }} </div>
        <div> 时间段：{{ SelItem.StartTime }} - {{ SelItem.EndTime }} </div>
        <div> 来访人员：{{ SelItem.UserWithName }}</div>
        <div> 来访人数：{{ SelItem.VistNum }} 人</div>
        <div> 陪同人员：{{ SelItem.VistUserName }}</div>
        <div> 陪同人数：{{ SelItem.UserWithNum }} 人</div>
        <mu-button slot="actions" flat color="primary" @click="InfoVisable = !InfoVisable">关闭</mu-button>
      </mu-dialog>
    </mu-container>
  </div>
</template>

<script>
import { GetSelDateList } from '@/api/all'
import Toast from 'muse-ui-toast'
import TimeTag from './TimeTag'
export default {
  name: 'Seat',
  components: { TimeTag },
  data() {
    return {
      TodyDate: new Date(),
      BookDate: new Date(),
      validateForm: {},
      BookTime: {
        MoTime: [],
        AfTime: []
      },
      InfoVisable: false,
      SelItem: {},
      SelItemList: []
    }
  },
  computed: {
    getBookTime: function() {
      return this.BookTime
    }
  },
  created() {
    this.GetTimeList()
  },
  methods: {
    GetTimeList: function() {
      this.InitPage()
      var Year = this.BookDate.getFullYear()
      var Month = this.BookDate.getMonth() + 1
      var Day = this.BookDate.getDate()
      var BookStr = Year + '-' + Month + '-' + Day
      GetSelDateList(BookStr).then(res => {
        var data = res.data
        this.BookTime.MoTime = data.Mo.map(v => {
          v.IsSel = 0
          v.IsCanSel = true
          return v
        })

        this.BookTime.AfTime = data.Af.map(v => {
          v.IsSel = 0
          v.IsCanSel = true
          return v
        })
        console.log(this.BookTime.MoTime)
        console.log(this.BookTime.AfTime)
      })
    },
    disableWeekends: function(date) {
      return date.getDay() === 0 || date.getDay() === 6
    },
    ShowSelInfo: function(item) {
      this.SelItem = item
      this.InfoVisable = true
    },
    AddSelItem: function(SelObj) {
      console.log(SelObj.index)
      console.log(SelObj.SelItem)
      if (this.SelItemList.length === 0) {
        this.SelItemList.push(SelObj.SelItem)
        this.SetOthDisable(SelObj.index, SelObj.SelItem)
        console.log(this.SelItemList)
      } else {
        this.SelItemList.push(SelObj.SelItem)
      }
    },
    RemSelItem: function(SelObj) {
      console.log(SelObj.index)
      console.log(SelObj.SelItem)
      console.log(this.SelItemList)
      var ThisIndex = this.SelItemList.indexOf(SelObj.SelItem)
      this.SelItemList.splice(ThisIndex, 1)
      if (this.SelItemList.length === 0) {
        this.SetOthAble()
      }
    },
    SetOthDisable: function(index, SelItem) {
      if (SelItem.TimeType === 1) {
        for (var i = 0; i < this.BookTime.AfTime.length; i++) {
          this.BookTime.AfTime[i].IsCanSel = false
        }
        // 前
        for (var ii = index; ii >= 0; ii--) {
          if (this.BookTime.MoTime[ii].IsBooked === 1) {
            for (var iii = ii; iii >= 0; iii--) {
              this.BookTime.MoTime[iii].IsCanSel = false
            }
            break
          }
        }
        // 后
        for (var jj = index; jj < this.BookTime.MoTime.length; jj++) {
          if (this.BookTime.MoTime[jj].IsBooked === 1) {
            for (var jjj = jj; jjj < this.BookTime.MoTime.length; jjj++) {
              this.BookTime.MoTime[jjj].IsCanSel = false
            }
            break
          }
        }
      } else if (SelItem.TimeType === 2) {
        for (var m = 0; m < this.BookTime.MoTime.length; m++) {
          this.BookTime.MoTime[m].IsCanSel = false
        }
        // 前
        for (var mm = index; mm >= 0; mm--) {
          if (this.BookTime.AfTime[mm].IsBooked === 1) {
            for (var mmm = mm; mmm >= 0; mmm--) {
              this.BookTime.AfTime[mmm].IsCanSel = false
            }
            break
          }
        }
        // 后
        for (var nn = index; nn < this.BookTime.AfTime.length; nn++) {
          if (this.BookTime.AfTime[nn].IsBooked === 1) {
            for (var nnn = nn; nnn < this.BookTime.AfTime.length; nnn++) {
              this.BookTime.AfTime[nnn].IsCanSel = false
            }
          }
        }
      }
    },
    SetOthAble: function() {
      for (var i = 0; i < this.BookTime.AfTime.length; i++) {
        this.BookTime.AfTime[i].IsCanSel = true
      }
      for (var j = 0; j < this.BookTime.MoTime.length; j++) {
        this.BookTime.MoTime[j].IsCanSel = true
      }
    },
    BookHandel: function() {
      if (this.SelItemList.length <= 0) {
        Toast.error('您还未选择预约时间！')
      } else {
        this.$emit('SeatSeled', this.SelItemList)
      }
    },
    DateChange: function(NewDate) {
      this.GetTimeList()
    },
    InitPage: function() {
      this.BookTime.MoTime = []
      this.BookTime.AfTime = []
      this.SelItem = {}
      this.SelItemList = []
    },
    CanselBook: function(SelItem) {
      this.$emit('CanselBook', SelItem)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/BookPage/components/Seat.vue